<template>
  <v-checkbox 
    v-model="isAdmin" 
    color="secondary"
    label="Admin" 
    :disabled="disabled"
    :persistent-hint="disabled"
    :hint="disabled ? 'Vous ne pouvez pas changer votre role' : ''"
  />
</template>

<script>
import {ROLE_ADMIN, ROLE_USER} from '@/config/roles'

export default {
  name: 'UserRoleSelector',
  props: {
    /**
     * Array containing user roles
     */
    value: {type: Array, required: true},
    disabled: {type: Boolean, required: false}
  },
  computed: {
    isAdmin: {
      get () {
        return this.value.includes(ROLE_ADMIN)
      },
      set (checked) {
        this.$emit('input', checked ? [ROLE_ADMIN] : [ROLE_USER])
      }
    }
  }
}
</script>